import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=47142e0b&scoped=true"
import script from "./FooterMain.vue?vue&type=script&lang=js"
export * from "./FooterMain.vue?vue&type=script&lang=js"
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=47142e0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47142e0b",
  null
  
)

export default component.exports